import { createAction, props } from '@ngrx/store';
import {
  IEmployeeRiskProductsResponse,
  IRiskProductOption,
  IStaticRiskProductOption,
  IUpdateEmployeeRiskProductRequest,
  IUpdateEmployeeRiskGroupRequest,
  IDeleteEmployeeRiskProductRequest
} from '../models/employee-risk-products.model';

export const loadEmployeeRiskProducts = createAction(
  '[EmployeeRiskProducts] Load Employee Risk Products',
  props<{ businessId: string; businessUserProfileId: string }>()
);

export const loadEmployeeRiskProductsSuccess = createAction(
  '[EmployeeRiskProducts] Load Employee Risk Products Success',
  props<{ response: IEmployeeRiskProductsResponse }>()
);

export const loadEmployeeRiskProductsFailure = createAction(
  '[EmployeeRiskProducts] Load Employee Risk Products Failure',
  props<{ error: Error | any }>()
);

export const updateEmployeeRiskGroup = createAction(
  '[EmployeeRiskProducts] Update Employee Risk Group',
  props<{ request: IUpdateEmployeeRiskGroupRequest }>()
);

export const updateEmployeeRiskGroupSuccess = createAction(
  '[EmployeeRiskProducts] Update Employee Risk Group Success',
  props<{ response: any }>()
);

export const updateEmployeeRiskGroupFailure = createAction(
  '[EmployeeRiskProducts] Update Employee Risk Group Failure',
  props<{ error: Error | any }>()
);

export const loadEmployeeBusinessRiskGroupOptions = createAction(
  '[EmployeeRiskProducts] Load Employee Business Risk Group Options',
  props<{ businessId: string }>()
);

export const loadEmployeeBusinessRiskGroupOptionsSuccess = createAction(
  '[EmployeeRiskProducts] Load Employee Business Risk Group Options Success',
  props<{ response: IRiskProductOption[] }>()
);

export const loadEmployeeBusinessRiskGroupOptionsFailure = createAction(
  '[EmployeeRiskProducts] Load Employee Business Risk Group Options Failure',
  props<{ error: Error | any }>()
);

export const updateEmployeeRiskProduct = createAction(
  '[EmployeeRiskProducts] Update Employee Risk Product',
  props<{ request: IUpdateEmployeeRiskProductRequest }>()
);

export const updateEmployeeRiskProductSuccess = createAction(
  '[EmployeeRiskProducts] Update Employee Risk Product Success',
  props<{ response: any }>()
);

export const updateEmployeeRiskProductFailure = createAction(
  '[EmployeeRiskProducts] Update Employee Risk Product Failure',
  props<{ error: Error | any }>()
);

export const deleteEmployeeRiskProduct = createAction(
  '[EmployeeRiskProducts] Delete Employee Risk Product',
  props<{ request: IDeleteEmployeeRiskProductRequest }>()
);

export const deleteEmployeeRiskProductSuccess = createAction(
  '[EmployeeRiskProducts] Delete Employee Risk Product Success',
  props<{ response: any }>()
);

export const deleteEmployeeRiskProductFailure = createAction(
  '[EmployeeRiskProducts] Delete Employee Risk Product Failure',
  props<{ error: Error | any }>()
);

export const loadRiskProductCalculationTypeOptions = createAction(
  '[EmployeeRiskProducts] Load Risk Product Calculation Type Options'
);

export const loadRiskProductCalculationTypeOptionsSuccess = createAction(
  '[EmployeeRiskProducts] Load Risk Product Calculation Type Options Success',
  props<{ response: IRiskProductOption[] }>()
);

export const loadRiskProductCalculationTypeOptionsFailure = createAction(
  '[EmployeeRiskProducts] Load Risk Product Calculation Type Options Failure',
  props<{ error: Error | any }>()
);

export const loadRiskProductDisplayTypeOptions = createAction(
  '[EmployeeRiskProducts] Load Risk Product Display Type Options'
);

export const loadRiskProductDisplayTypeOptionsSuccess = createAction(
  '[EmployeeRiskProducts] Load Risk Product Display Type Options Success',
  props<{ response: IRiskProductOption[] }>()
);

export const loadRiskProductDisplayTypeOptionsFailure = createAction(
  '[EmployeeRiskProducts] Load Risk Product Display Type Options Failure',
  props<{ error: Error | any }>()
);

export const loadStaticRiskProductOptions = createAction('[EmployeeRiskProducts] Load Static Risk Product Options');

export const loadStaticRiskProductOptionsSuccess = createAction(
  '[EmployeeRiskProducts] Load Static Risk Product Options Success',
  props<{ response: IStaticRiskProductOption[] }>()
);

export const loadStaticRiskProductOptionsFailure = createAction(
  '[EmployeeRiskProducts] Load Static Risk Product Options Failure',
  props<{ error: Error | any }>()
);
